import { render, staticRenderFns } from "./SignUpThanksPage.vue?vue&type=template&id=692664af&scoped=true"
import script from "./SignUpThanksPage.vue?vue&type=script&lang=js"
export * from "./SignUpThanksPage.vue?vue&type=script&lang=js"
import style0 from "./SignUpThanksPage.vue?vue&type=style&index=0&id=692664af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692664af",
  null
  
)

export default component.exports